import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Receipt } from '@contracts/interfaces/receipt.interface';


@Injectable({
    providedIn: 'root'
})
export class ChatGPTService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService) { }

    prompt(message: string, model?: string) {
        return this.http.post(this.connectionService.address + "/chatgpt-service/prompt", { message, model });
    }

    PDFReceipt(receipt: Receipt) {
        return this.http.post(this.connectionService.address + "/chatgpt-service/pdf-receipt", {receipt});
    }

    imageReceipt(receipt: Receipt) {
        return this.http.post(this.connectionService.address + "/chatgpt-service/image-receipt", {receipt});
    }
}
